var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtpVerifyedSucesssvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 149,
    viewBox: "0 0 150 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 74.5,
    r: 74.5,
    fill: "#FAE7B6",
    fillOpacity: 0.09
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.0001,
    cy: 74.4981,
    r: 65.631,
    fill: "#FFFBE5",
    fillOpacity: 0.09
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.0002,
    cy: 74.4963,
    r: 56.7619,
    fill: "#31B948"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.202 55.9106L98.6365 54.3466C96.9176 52.624 94.1014 52.624 92.377 54.3466L65.7931 80.9341L56.36 71.5047C54.6411 69.784 51.823 69.784 50.1041 71.5066L48.5402 73.0687C46.8212 74.7894 46.8212 77.6057 48.5402 79.3264L62.656 93.4569C64.3768 95.1758 67.193 95.1758 68.9137 93.4569L100.202 62.1683C101.919 60.4476 101.919 57.6313 100.202 55.9106Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpVerifyedSucesssvg);
export default __webpack_public_path__ + "static/media/otp-verifyed-sucess.svg.ce0d8952ed31a1a076bba458d4d1b78d.svg";
export { ForwardRef as ReactComponent };